module.exports = __webpack_public_path__ + "static/media/logo.8980c323.png";